export default __webpack_public_path__ + "static/Natural_Light_Outdoor_1280kbps-482f82e0f8b6de29db24416e201b4c7c.avif";